// useInvoiceCalculations.js - Custom hook for calculating totals.
import { useState, useEffect } from 'react';
import { calculateTotals } from '../utils/calculations';

const useInvoiceCalculations = (items, taxRate, discountRate) => {
  const [subTotal, setSubTotal] = useState('0.00');
  const [taxAmount, setTaxAmount] = useState('0.00');
  const [discountAmount, setDiscountAmount] = useState('0.00');
  const [total, setTotal] = useState('0.00');

  useEffect(() => {
    const { subTotalValue, taxAmountValue, discountAmountValue, totalValue } = calculateTotals(items, taxRate, discountRate);
    setSubTotal(subTotalValue);
    setTaxAmount(taxAmountValue);
    setDiscountAmount(discountAmountValue);
    setTotal(totalValue);
  }, [items, taxRate, discountRate]);

  return { subTotal, taxAmount, discountAmount, total };
};

export default useInvoiceCalculations;